/**
 * this class generated to use axios custom instance on "openapi axios" client.
 *
 * reference:
 * https://github.com/ferdikoomen/openapi-typescript-codegen/blob/80304d996a2ae79193550ae828b945e73d32d348/docs/axios-support.md
 */

import axios from 'axios'
import axiosRetry from 'axios-retry'
import {request as __request} from 'openapi/core/request'
import {CancelablePromise} from 'openapi/core/CancelablePromise'
import {BaseHttpRequest} from 'openapi/core/BaseHttpRequest'
import {ApiRequestOptions} from 'openapi/core/ApiRequestOptions'
import type {OpenAPIConfig} from 'openapi/core/OpenAPI'

export class CustomAxiosHttpRequest extends BaseHttpRequest {
  axiosInstance = axios.create()

  constructor(config: OpenAPIConfig) {
    super(config)
    axiosRetry(this.axiosInstance, {
      retries: 0,
      retryDelay: axiosRetry.exponentialDelay,
    })
  }

  public override request<T>(options: ApiRequestOptions): CancelablePromise<T> {
    return __request(this.config, options, this.axiosInstance)
  }
}
